import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Retourne la description de la propriété du product item dans la langue courante
 * Usage:
 *   property  | getProductItemPropertyDescription : itemPropertyList
 * Example:
*/

@Pipe({
  name: 'getProductItemPropertyDescription'
})

export class ProductItemPropertyDescriptionPipe implements PipeTransform {

  constructor(private translateService: TranslateService,) {}

  transform(value: any, cvlFieldList: any): string {
    let local = this.translateService.currentLang.toLowerCase();
    if (!cvlFieldList) return '';
    // find value in cvlFieldList
    let found = cvlFieldList.find((item: any) => item.safestockPropertyName.toLowerCase() === value.toLowerCase());
    if (found)
      return local == 'en' ? found.fieldTypeDisplayNameEn : found.fieldTypeDisplayNameFr;
    else
      return value;
  }
}